import React from "react";
import analytics from "web/script/analytics/analytics";
import { showMainNavigation, hideMainNavigation } from "web/redux/ducks/main-navigation";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import styles from "./main-navigation-toggle-mobile.css";

const MENU_OPENED = "opened";
const MENU_CLOSED = "closed";

function extractNavigation(state) {
    return state.mainNavigationReducer;
}

export function MainNavigationToggleMobile() {
    const { selectedGender, visible } = useReduxSelector(extractNavigation);
    const dispatch = useDispatch();

    function sendAnalytics(menuVisibility) {
        const gender = selectedGender || "women";
        analytics.event("nav", menuVisibility, `nav_${gender.toLowerCase()}_menu`);
    }

    function toggleVisibility() {
        if (visible) {
            dispatch(hideMainNavigation());
            document.body.classList.remove("no-scroll");
            sendAnalytics(MENU_CLOSED);
        } else {
            dispatch(showMainNavigation());
            document.body.classList.add("no-scroll");
            sendAnalytics(MENU_OPENED);
        }
    }

    return (
        <button
            className={visible ? styles.burgerCross : styles.burgerContainer}
            onClick={() => toggleVisibility()}
        >
            <div className={styles.burgerBar1} />
            <div className={styles.burgerBar2} />
            <div className={styles.burgerBar3} />
        </button>
    );
}

export default withReduxProvider(MainNavigationToggleMobile);
